import { SweetPath } from 'sweet-path';

// Dashboard
export const DASHBOARD_PATH = new SweetPath('/');

// MyDocumentsPage
export const MYDOCUMENTS_PAGE_PATH = new SweetPath('/mydocuments');
export const DOCUMENT_DETAIL_PAGE_PATH = new SweetPath('/mydocuments/:documentId');

//  InstructionsPage
export const INSTRUCTIONS_PAGE_PATH = new SweetPath('/instructions');

//  InstructionsPageDetail
export const INSTRUCTIONS_DETAIL_PAGE_PATH = new SweetPath('/instructions/:id');

//  FAQPage
export const FAQ_PAGE_PATH = new SweetPath('/faq');

//  HelpdeskPage
export const HELPDESK_PAGE_PATH = new SweetPath('/helpdesk');

//  HelpdeskPageDetail
export const HELPDESK_DETAIL_PAGE_PATH = new SweetPath('/helpdesk/:id');

//  TicketPage
export const TICKET_PAGE_PATH = new SweetPath('/ticket');

//  HousePage
export const HOUSE_PAGE_PATH = new SweetPath('/house');

//  EcvPage
export const ECV_PAGE_PATH = new SweetPath('/ecv');

//  EcvAddPage
export const ECV_ADD_PAGE_PATH = new SweetPath('/ecv-add');

//  EcvEditPage
export const ECV_EDIT_PAGE_PATH = new SweetPath('/ecv/:id');

//  RfidPage (List of chips)
export const RFID_PAGE_PATH = new SweetPath('/rfid');

//  RfidAddPage
export const RFID_ADD_PAGE_PATH = new SweetPath('/rfid-add');

//  RfidPairPage
export const RFID_PAIR_PAGE_PATH = new SweetPath<'deviceId'>('/rfid/pair/:deviceId');

//  PinCodePage
export const PIN_CODE_PAGE_PATH = new SweetPath('/pin-code');

//  TemporaryPinCodePage
export const TEMPORARY_PIN_CODE_PAGE_PATH = new SweetPath('/temporary-pin-codes');

//  UsersPage (Household users)
export const USERS_PAGE_PATH = new SweetPath('/users');

//  UserAddPage
export const USER_ADD_PAGE_PATH = new SweetPath('/users/add');

// UserPinCodePage
export const USER_PIN_CODE_PAGE_PATH = new SweetPath<'userId'>('/users/:userId/pin-code');

// UserTemporaryPinCodePage
export const USER_TEMPORARY_PIN_CODE_PAGE_PATH = new SweetPath<'userId'>('/users/:userId/temporary-pin-codes');

// Sensor
export const SENSOR_DETAIL_PAGE_PATH = new SweetPath('/sensors/sensor/:sensorId');

// SensorEdit
export const SENSOR_DETAIL_EDIT_PAGE_PATH = new SweetPath('/sensors/sensor/edit/:sensorId');

// AirConditioner landing (device selection / auth)
export const AIR_CONDITIONER_PAGE_PATH = new SweetPath('/air-conditioner');

// AirConditioner detail
export const AIR_CONDITIONER_DETAIL_PAGE_PATH = new SweetPath('/air-conditioner/:airConditionerId');

// Tuya device detail
export const TUYA_DEVICE_DETAIL_PAGE_PATH = new SweetPath<'tuyaDeviceId'>('/tuya-device/:tuyaDeviceId');

// Garage
export const GARAGE_PAGE_PATH = new SweetPath('/garage/:id');

// EV Charging Station
export const EV_CHARGING_STATION_PAGE_PATH = new SweetPath<'evChargingStationId'>(
  '/ev-charging-station/:evChargingStationId'
);

// Spot Comparator
export const SPOT_COMPARATOR_PATH = new SweetPath('/spot-porovnavac');

// Energy Consumption
export const ENERGY_CONSUMPTION_PATH = new SweetPath('/tuya-device/energy-consumption/:deviceId');

// Error pages
export const FORBIDDEN_PAGE_PATH = new SweetPath('/403');

// Chatbot pages
export const CHATBOT_PAGE_PATH = new SweetPath('/chatbot');

// Door Bell pages
export const DOOR_BELL_PAGE_PATH = new SweetPath('/doorbell');

// Call Order page
export const CALL_ORDER_PAGE_PATH = new SweetPath('/call-order');

// Set Phone page (primary GSM)
export const SET_PHONE_PAGE_PATH = new SweetPath('/call-order/set-phone');

// Set Second Phone page
export const SET_SECOND_PHONE_PAGE_PATH = new SweetPath('/call-order/set-second-phone');
